// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"UserNameCard_wrapper__18u-6","name":"UserNameCard_name__1sQRe","link":"UserNameCard_link__22PXl"};